export function toForwardSlashes(s: string): string {
    return s.replace(/\\/g, '/');
}
